import { AuthStorage } from '../infrastructure/authStorage';

export class IsAuthenticatedUseCase {
  private authStorage: AuthStorage;

  constructor() {
    this.authStorage = new AuthStorage();
  }

  execute(): boolean {
    return this.authStorage.hasAccessToken();
  }
}

